import * as React from 'react';
import { api, handleApiError } from 'services/api';
import { createLinkAndDownload } from 'utils';

export type DeliveryVoucherFileResponse = {
  url: string;
  fileName: string;
};

export const useDeliveryVoucher = () => {
  const fetchVoucherFile = React.useCallback(async (voucherId: number) => {
    try {
      const { data } = await api.get<DeliveryVoucherFileResponse>(
        `/delivery-vouchers/download/${voucherId}`
      );

      return data;
    } catch (e) {
      throw handleApiError(e);
    }
  }, []);

  const downloadVoucher = React.useCallback(
    async (voucherId: number) => {
      const data = await fetchVoucherFile(voucherId);

      createLinkAndDownload(data.url, data.fileName);
    },
    [fetchVoucherFile]
  );

  return {
    fetchVoucherFile,
    downloadVoucher,
  };
};
